<template>
  <v-app class="pa-6">
    <Header />
    <v-main class="content">
      <Sidebar /> 
      <router-view />
      <TheSideview />
      <TheModal/>
      <TheSecondModal />
      <TheSnackbar/>
      <Footer />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Header from "@/components/Header/Header.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Footer from "@/components/Footer/Footer.vue";
import TheModal from "@/components/TheModal.vue";
import TheSideview from "@/components/TheSideview.vue";
import TheSnackbar from "@/components/TheSnackbar.vue"
import TheSecondModal from "../TheSecondModal.vue";

@Component({
  components: { Footer, Header, Sidebar, TheModal, TheSideview, TheSnackbar, TheSecondModal },
})
export default class Layout extends Vue {
  closeOnClick = true;
  items_actions = [
    { title: this.$i18n.t("view"), route: "installations" },
    { title: this.$i18n.t("edit"), route: "installations" },
    { title: this.$i18n.t("delete"), route: "installations" },
  ];
}
</script>

<style lang="scss">
@import "../../styles/app.scss";
.v-main__wrap {
  padding: 70px $content-padding $content-padding;
}
.content {
  background-color: $body-bg;
}
</style>
